import { Component, OnInit, Inject, Output, EventEmitter } from '@angular/core';  ///----------- for searching pop up -----------
import { LocalStorageService } from 'ngx-webstorage';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';         ///----------- for searching pop up -----------
import { formatDate } from '@angular/common';
import { ExaminationService } from 'src/app/services/ExaminationService';
import { ExaminationModel } from 'src/app/models/ExaminationModel';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-ex-attach-view',
  templateUrl: './ex-attach-view.component.html',
  styleUrls: ['./ex-attach-view.component.css']
})
export class ExAttachViewComponent implements OnInit {
  patientcode  ='';
  dateentry= formatDate(new Date(), 'yyyy-MM-dd', 'en');

  diimage :any ;
  myimage :any;
  imageSrc;
  imageSource: any;

  sellersPermitFile: any;
  sellersPermitString :any;
  @Output() submitClicked = new EventEmitter<any>();

  constructor(public dialogRef: MatDialogRef<ExAttachViewComponent>,   ///----------- for searching pop up -----------
  public examinationservice: ExaminationService,
  public examination: ExaminationModel,
  public storage: LocalStorageService,
  public examinationSelectedData: ExaminationModel,
  private sanitizer: DomSanitizer,
  @Inject(MAT_DIALOG_DATA) public data: any                                  ///----------- for searching pop up -----------

  ) {
    this.patientcode = data.wk_patientcode,
    this.dateentry = data.wk_dateentry
  }

  ngOnInit(): void {
    this.retriveExAttach();
  }
  retriveExAttach()
  {
     this.examinationservice
    .getexamination(this.patientcode,this.dateentry, this.storage.retrieve('stgcompCode'))
    .subscribe((data: ExaminationModel) => {
      this.myimage = data.exattach;
      this.sellersPermitString =  data.exattach;
      this.myimage =this.sellersPermitString;
      var kk = this.sellersPermitString;
      this.imageSource = this.sanitizer.bypassSecurityTrustResourceUrl('data:image/jpg;base64,' + this.sellersPermitString);
    }
    );
  }
  handleInputChange(files: any) {
    var file = files;
    var pattern = /image-*/;
    var reader = new FileReader();
    if (!file.type.match(pattern)) {
      alert('invalid format');
      return;
    }

    reader.onloadend = this._handleReaderLoaded.bind(this);
    reader.readAsDataURL(file);
  }
  _handleReaderLoaded(e: any) {
    let reader = e.target;
    var base64result = reader.result.substr(reader.result.indexOf(',') + 1);
    this.imageSrc = base64result;
    this.sellersPermitString = base64result;
    this.myimage =this.sellersPermitString;
    var kk = this.sellersPermitString;

    this.imageSource = this.sanitizer.bypassSecurityTrustResourceUrl('data:image/jpg;base64,' + this.sellersPermitString);


  }
}
